import axios from "axios";
import api from "../api";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import csrftoken from "../getToken";
import moment from "../../node_modules/moment/src/moment.js";
// import PatientsGQL from "../gql/getPatients.gql";
import PatientsGQLByPage from "../gql/getPatientsByPage.gql";
// 获取某患者的详细 action 信息
import getPatientsPatientList from "../gql/getPatientsPatientList.gql";
// 获取某患者的详细 action 数量信息
import getPatientActionNum    from "../gql/getPatientActionNum.gql";
import raceJson from "../race.js";
import gql from "graphql-tag";
import PatientDiagnoseRecord from "../components/PatientDiagnoseRecord.vue";
import DetailedResults from "../components/DetailedResults.vue";
import FilterGQL from "../gql/filter.gql";
import PatientsPaging from "../gql/patientsPaging.gql";
import getCohortPatientsGql from "../gql/cohortPatientsPaging.gql";
import InHospital from "../utils/inHospital.js";
import vitiligoBasicInfo from "../utils/vitiligoBasicInfo.js";
import mmBasicInfo from "../utils/mmBasicInfo.js";
import patientsSearch from "../utils/patientsSearch.js";
import operationDoctor from "../assets/operationDoctor.jpg";
import popMixins from "../utils/popMixins.js";
import controllerDuration from "../utils/controllerDuration.js";
import cohort from "./cohort.js";

// 医生自定义模板
let template = {};
let that;
export default {
  name: "Cohort",
  data() {
    const checkIdInHospital = async (rule, value, callback) => {
      if (this.form2.patientNumber === "") {
        callback("请输入ID");
      } else {
        const bool = await this.patientIdRepeat(this.form2.patientNumber);
        if (bool) {
          callback("ID已存在");
        }
      }
    };
    const checkIdCardNumber = async (rule, value, callback) => {
      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (value === "") {
        callback();
        this.form2Verify.id_card_number = true;
      } else {
        if (reg.test(value)) {
          callback();
          this.form2Verify.id_card_number = true;
        } else {
          callback("");
          this.form2Verify.id_card_number = false;
        }
      }
    };
    // 校验电话号码
    const checkPhone = (rule, value, callback) => {
      let reg = /^1\d{10}/;
      if (reg.test(value)) {
        callback();
        this.form2Verify.phone = true;
      } else {
        callback("");
        this.form2Verify.phone = false;
      }
    };
    return {
      operationDoctor,
      hospitalization_imagesThumbnails: api.hospitalization_imagesThumbnails,
      imageSrcPrefixThumbnails: api.imageSrcPrefixThumbnails,
      imageSrcPrefixThumbnails2: api.cosmetology_imagesThumbnails,
      // 分页相关参数
      prevDisabled: true,
      nextDisabled: true,
      currentPagePatientList: 1,

      inlineForm: true,
      readonly: false,
      // 显示单独的诊断记录
      singleDiagnose: false,
      skinOps: raceJson.skinOpn,
      skinOpsType:raceJson.skinOpnType,
      // 是否显示比较图片的弹框
      compareDialog: false,
      // 显示全部诊断信息
      showall: false,
      // 年龄数据
      ageValues: raceJson.age,
      // 选择的年龄
      checkedAge: 0,
      // 民族数据
      nationValues: raceJson.raceObj,
      // checked nation
      checkedNation: "",
      // resiltsVisible 是否显示智能搜图结果
      resiltsVisible: false,
      compareImgObj: {},
      patients: [],
      // patients2: [],
      resultArr: [],
      diagnoses: [],
      // 单个patient 的 各类activion的数量，按顺序包括影像、手术、住院、美容等,后续可以扩展
      //currentDiagnosesNum:{"dignoses":0, "operation":0, "inHospital":0, "cosmetology":0 },
      detail_result: [],
      imgList3: [],
      currentIndex: null,
      isHid: false,
      wordbook: null,
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      options: [
        {
          value: "",
          label: "请选择性别"
        },
        {
          value: "男",
          label: "男"
        },
        {
          value: "女",
          label: "女"
        }
      ],
      keywordString: "",
      input2: null,
      sex: "",
      value1: null,
      startAge: "",
      endAge: "",
      sDate: "",
      diagnosis_type:'',
      diagnosisTypeList:[
        {key:1,val:'影像诊断'},{key:2,val:'美容/治疗'},{key:3,val:'手术'},{key:4,val:'住院'}
      ],
      knowledgeDic: {},
      form: {
        name: "",
        gender: "男",
        phone: "",
        race: "",
        birthday: "",
        patientNumber: "",
        address: "",
        skin_color: "",
        skin_type:""
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
        birthday: [{ required: true, trigger: "blur" }],
        id_in_hospital: {
          required: true,
          validator: checkIdInHospital,
          trigger: "blur"
        }
        // id_card_number: {
        //   required: false,
        //   validator: checkIdCardNumber,
        //   trigger: "blur"
        // }
      },
      form2: {
        // 患者的id
        id: "",
        patientNumber: "",
        name: "",
        gender: "男",
        address: "",
        phone: "",
        race: "",
        birthday: "",
        age: "",
        skin_color: "",
        id_card_number: "",
        native_place: "",
        country: "",
        profession: "",
        email: "",
        skin_type: "",
      },
      form2Verify: {
        id: true,
        phone: true,
        id_card_number: true
      },
      rules2: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 64, message: "长度在 2 到 64 个字符", trigger: "blur" }
        ],
        age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
        birthday: [{ required: true, trigger: "blur" }],
        patientNumber: [
          { required: true, message: "请输入门诊号", trigger: "blur" }
        ]
      },
      patientId: "",
      patientId2: "",
      showInfo: false,
      diagnosisId: "",
      reviseInfo: false,
      allNum: 0,
      isdel: false,
      deletePatientId: null,
      activeName: "0",
      moreResultArr: [],
      // 传递给子组件的患者信息
      patientInfo: {},
      // 传递给子组件的诊断信息
      diagnoseInfo: [],
      waiting: true,
      // 下载数据时提示
      getPatientListLoading: false,
      // 百科全书
      wordbook: {},
      // 分页显示条数
      currentPagePatientList:1,
      pageTotal:0,
      pageSizePatientList: 10,
      initialTime: -30610253143000, // 初始时间1000-01-01 00:00:00
      hasClumsOpen: false, // 是否有列表被展开
      orderStatus: "desc", // false为倒叙，true为正序
      orderFiled: "update_time", // 排序名称
      form2IdDisabled: true,
      isAddPatient: false,
      // 限制显示编辑按钮的时间值 毫秒
      // countTimeModifyDiagnosisBtn: 604800000,
      
      // 随访患者选择，全选状态
      isIndeterminate: false,
      checkAll: false,
      // 勾选的拟加入随访的患者数量
      checkedNum:0,
      // 加入随访按钮的使能
      followup_disabled: true,
      // 显示云胶片状态对话框
      showOnlineReportDetail: false,
      // 云胶片具体信息
      onlineReport:{}, 
      // 短信多大发送次数
      maxSmsSentTimes: 3,
    };
  },
  mixins: [InHospital, vitiligoBasicInfo, mmBasicInfo, patientsSearch, popMixins, controllerDuration],
  async mounted() {
    that = this;
    // 请求医生自定义模板
    await this.queryMyTemplate();
    let res1 = await axios.request({
      method: "get",
      url: api.wordbook,
      headers: {
        "x-csrf-token": csrftoken
      },
      withCredentials: true
    });
    this.wordbook = res1.data;
    // this.orderStatus = "desc";
    // 请求患者基本数据
    // console.log("In patientlist, mounted, and begin getCohortPatients.");
    this.getCohortPatients();
    axios
      .request({
        method: "get",
        url: api.wordbook,
        headers: {
          "x-csrf-token": csrftoken
        },
        withCredentials: true
      })
      .then(res => {
        this.wordbook = res.data;
      })
      .catch(error => {
        // console.log(error);
      });
    const knowledgeDic = await axios.request({
      method: "get",
      url: api.knowledgeDic
    });
    this.knowledgeDic = knowledgeDic.data;
  },


  // activated() {
  //   console.log("In patientList, activated.");
  // },
  // created() {
  //   console.log('In patientList, created')
  // },

  methods: {
    async handleCurrentChange(val) {
      this.currentPagePatientList = val;
      await this.getCohortPatients();
      //await this.getPatientsDiagnoses();
    },
    async querySearchPatientNumber(queryString, callback) {
      if (queryString !== "") {
        const res = await this.$apollo.query({
          query: gql`query($keyword: String){
                      patients(keyword: $keyword) {
                        id
                        id_in_hospital
                      }
                  }`,
          fetchPolicy: "no-cache",
          variables: {
            keyword: queryString,
          },
        });
        const arr = res.data.patients;
        const newArr = [];
        for (let i of arr) {
          newArr.push({
            value: `${i.id_in_hospital}`,
            id: i.id
          });
        }
        callback(newArr);
      }
    },
    selectPatientNumber() {
      this.$refs.form22.validateField('id_in_hospital');
    },

    getOperationl(data, patientinfo) {
      // console.log(data,item)
      this.$store.commit("setoperationClearClick", true);
      this.$store.commit("seteditOperation", true);
      this.$store.commit("setoperationPatientId", patientinfo.id);
      this.$store.commit("setoperationElectiveId", data.id);
      this.$store.commit("setoperationRelevantId", data.relevant_info[0].id);
      this.$router.push({ name: "operation" });
    },
    // 检查患者id是否重复
    async patientIdRepeat(value) {
      const res = await this.$apollo.query({
        query: gql`
          query($id_in_hospital: String!) {
            getByIdInHospital(id_in_hospital: $id_in_hospital) {
              id
            }
          }
        `,
        variables: {
          id_in_hospital: value
        },
        fetchPolicy: "no-cache"
      });
      const arr = res.data.getByIdInHospital;
      
      return arr.length > 0;
    },
    reviseInfoClose() {
      // 初始化状态
      this.$refs.id_in_hospital.resetField();
      this.$refs.form2Name.resetField();
      this.form2IdDisabled = true;
      this.form2 = {
        // 患者的id
        id: "",
        patientNumber: "",
        name: "",
        gender: "男",
        address: "",
        phone: "",
        race: "",
        birthday: "",
        age: "",
        skin_color: "",
        skin_type: "",
        id_card_number: "",
        native_place: "",
        country: "",
        profession: "",
        email: ""
      };
      this.isAddPatient = false;
    },
    async order(data) {
      if (this.orderStatus === "asc") {
        this.orderStatus = "desc";
      } else {
        this.orderStatus = "asc";
      }
      // "asc",'desc'
      this.orderFiled = data;
      // console.log(data)
      await this.getCohortPatients();
      //await this.getPatientDiagnoses();
    },
    // 添加新的患者
    newPatient() {
      this.reviseInfo = true;
      this.form2IdDisabled = false;
      this.isAddPatient = true;
    },
    // 添加患者
    async addPatient() {
      const newval = this.form2;
      if (!newval.patientNumber) {
        this.$message.error("请输入ID");
        return;
      }
      if (!newval.name) {
        this.$message.error("请输入姓名");
        return;
      }
      if (!newval.birthday && !this.form2.age) {
        this.$message.error("出生年月和年龄至少填一项");
        return;
      }
      const bool = await this.patientIdRepeat(this.form2.patientNumber);
      if (!bool) {
        let addRes = await this.addSicker(newval);
        // 刷新患者列表
        if (addRes) {
          await this.refreshPatientList();
          this.$message({
            type: "success",
            message: "添加患者成功"
          });
          this.reviseInfo = false;
        }
      }
    },
    // 请求添加病人
    async addSicker(params) {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation(
              $id_in_hospital: String!
              $name: String!
              $gender: String!
              $birthday: String!
              $age: Int
              $race: String!
              $skin_color: String!
              $skin_type: String!
              $phone: String!
              $address: String!
              $id_card_number: String!
              $native_place: String!
              $country: String!
              $profession: String!
              $email: String!
            ) {
              addPatient(
                id_in_hospital: $id_in_hospital
                name: $name
                gender: $gender
                birthday: $birthday
                race: $race
                skin_color: $skin_color
                skin_type: $skin_type
                phone: $phone
                address: $address
                id_card_number: $id_card_number
                native_place: $native_place
                country: $country
                profession: $profession
                email: $email
                age: $age
              ) {
                id
              }
            }
          `,
          variables: {
            id_in_hospital: params.patientNumber,
            name: params.name,
            gender: params.gender,
            birthday: params.birthday
              ? params.birthday
              : moment(this.initialTime).format("YYYY-MM-DD"),
            age: params.age ? Number(params.age) : -1,
            race: params.race,
            skin_color: params.skin_color,
            skin_type: params.skin_type,
            phone: params.phone,
            address: params.address,
            id_card_number: params.id_card_number,
            native_place: params.native_place,
            country: params.country,
            profession: params.profession,
            email: params.email
          }
        });
        return true;
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
        return false;
      }
    },
    // 添加患者到随访列表
    async newFollowup(){ 
      let hintMessage = "将添加" + this.checkedNum + "名患者进入随访队列";
      this.$confirm(hintMessage, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            console.log("In newFollowup");
            let newFollowupPatients = [];
            console.log(this.patients);
            for (let item of this.patients) {
                if (item.checked){
                  // console.log(item.doctor_id); // It's a regret, undefined!!
                  newFollowupPatients.push({  
                    // doctor_id: item.doctor_id,        
                    patient_id: item.id, 
                    name: item.name,
                    gender: item.gender, 
                    id_in_hospital: item.id_in_hospital           
                  });
                }
            }
            newFollowupPatients = JSON.stringify(newFollowupPatients);
            this.$store.commit("setHasAddedNewFollowupPatient", false);
            console.log("newFollowup,setHasAddedNewFollowupPatient:",this.$store.state.hasAddedNewFollowupPatient);
            // 新开随访页签并跳转到随访页签
            let routeUrl = this.$router.resolve({
              path: "followup",
              query: {'newFollowupPatients':newFollowupPatients}
            });
            window.open(routeUrl.href, '_blank');
            // console.log("newFollowup: navigate to new tab page.newFollowupPatients",newFollowupPatients);
          } catch (error) {
            this.$message.error(error.message.split(":")[1]);
          }
        })
        .catch(() => {
          // console.log('取消删除');
        });
    },
    // 获取医生自定义模板
    async queryMyTemplate() {
      // 请求医生自定义的模板路径
      const res = await this.$apollo.query({
        query: gql`
          {
            me {
              id
              template
            }
          }
        `,
        fetchPolicy: "no-cache"
      });
      // 根据路径请求模板
      const path = res.data.me.template;
      // 如果没有自定义模板
      if (path === "") {
        return;
      }
      const msg = await axios.request({
        method: "get",
        url: api.template + path
      });
      template = msg.data;
    },
    background(type) {
      if (type === "住院") {
        return "#fff3cd";
      } else if (type === "手术") {
        return "#EBFDE8";
      } else if (type === "美容") {
        return "rgb(254,216,216)";
      }else if (type === "白癜风基础") {
        return "rgb(220,246,246)";
      }else if (type === "黑色素瘤") {
        return "rgb(230,230,250)";
      }
    },
    typeBadge(type) {
      const map = {
        '影像': '影',
        '美容': '美',
        '住院': '院',
        '手术': '术',
        '白癜风基础': 'V',
        '黑色素瘤': 'M'
      };
      return map[type] || '';
    },
    typeBadgeColor(type) {
      const map = {
        '影像': '#999999',
        '美容': '#c86a6a',
        '住院': '#c8aa3c',
        '手术': '#50a046',
        '白癜风基础': '#3ca0a0',
        '黑色素瘤': '#6464b4'
      };
      return map[type] || '#999999';
    },
    // 算年龄
    getAge(birthday, age, createdTime) {
      let showAge;
      if (birthday !== this.initialTime) {
        showAge = moment().diff(birthday, "years");
      } else if (age > -1) {
        showAge = age + moment().diff(createdTime, "years");
      }
      return showAge;
    },
    // 患者列表上显示的打印状态
    handlePrintStatus(diagnoses) {
      let status = '无';
      if (diagnoses.length > 0) {
        let num = 0;
        for (const item of diagnoses) {
          if (item.images) {
            const index = item.images.findIndex(
              item => item.print_time !== this.initialTime
            );
            // diagnosesItem.isPrintReport = !(index > -1);
            if (index > -1) {
              num++;
            }
          }
        }
        if (num === diagnoses.length) {
          status = '完成打印';
        } else {
          status = '未打印';
        }
      }
      return status;
    },
    
    // check whether online_report_state error/regular/note, set different style. 2024-0507
    handleOnlineReportStatus(online_report_state) {
      let status = '';
      // error
      if ( online_report_state.indexOf('手机号缺失') != -1  || online_report_state.indexOf('失败') != -1) {
        status = -1;
        // regular
      } else if(online_report_state.indexOf('已查阅') != -1) {
        status = 0;
        // note
      }else if(online_report_state.indexOf('未查阅') != -1) {
        status = 1;
      }
      return status;
    },
    // 全选或取消
    handleCheckAllChange(val) {
      this.checkAll = val;
      console.log("In handleCheckAllChange, val:", this.checkAll)
      this.isIndeterminate = false;
      if (val){
        for (const item of this.patients) {
          item.checked = true;
        }
        this.checkedNum = this.patients.length;
        this.followup_disabled = false
      } else {
        for (const item of this.patients) {
          item.checked = false;
        }     
        this.checkedNum = 0;
        this.followup_disabled = true
      }
    },

    handleCheckChange(val) {      
      var num = 0; 
      for (const item of this.patients) {
          if (item.checked){
            num += 1;
          }
      }
      this.checkedNum = num;
      if (num === this.patients.length){
        this.checkAll = true;
        this.isIndeterminate = false;
        this.followup_disabled = false;
      } else if (num===0){
        this.checkAll = false;
        this.isIndeterminate = false;    
        this.followup_disabled = true    
      } else {
        this.checkAll = false;
        this.isIndeterminate = true;
        this.followup_disabled = false;
      }

    },

    async compare(data) {
      let self = this;
      data.choosedImg = data.choosedImg.replace("thumbnails/", "");
      await this.adaptImage(data.choosedImg, "choosedWidth", "choosedHeight");
      await this.adaptImage(data.compareImg, "compareWidth", "compareHeight");
      this.compareImgObj.choosedImg = data.choosedImg;
      this.compareImgObj.compareImg = data.compareImg;
      this.compareDialog = true;
    },
    adaptImage(url, typeWidth, typeHeight) {
      let self = this;
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.src = url;
        img.onload = () => {
          let width = img.width;
          let height = img.height;
          if (width / height < 654 / 500) {
            img.height = 500;
            img.width = (width * 500) / height;
          } else {
            img.width = 654;
            img.height = (height * 654) / width;
          }
          self.compareImgObj[typeWidth] = img.width;
          self.compareImgObj[typeHeight] = img.height;
          resolve();
        };
      });
    },
    closeResult() {
      this.resiltsVisible = false;
    },
    // 显示所有的诊断记录信息
    showAll() {
      this.showall = true;
      // 分割数据
    },
    showHid(index, id) {
      this.showall = false;
    },
    getMessageFromChildren(data) {
      switch (data.type) {
        case "showIntell":
          this.detail_result = data.detail_result;
          this.imgList3 = data.imgList;
          this.resiltsVisible = true;
          break;
      }
    },
    async revisePatient() {
      // const isSuccessful = this.form2Verify.id_card_number === true && this.form2.name !== '' &&
      //   this.form2.birthday !== '' && this.form2.id !== '' && this.form2.gender !== '';
      // if (!isSuccessful) {
      //   this.$message.error('格式不正确');
      //   return;
      // }
      if (!this.form2.name) {
        this.$message.error("请输入姓名");
        return;
      }
      if (!this.form2.birthday && !this.form2.age) {
        this.$message.error("出生年月和年龄至少填一项");
        return;
      }
      const params = {
        id: this.form2.id,
        id_in_hospital: this.form2.patientNumber,
        name: this.form2.name,
        birthday: this.form2.birthday
          ? this.form2.birthday
          : moment(this.initialTime).format("YYYY-MM-DD"),
        gender: this.form2.gender,
        race: this.form2.race,
        skin_color: this.form2.skin_color,
        skin_type: this.form2.skin_type,
        phone: this.form2.phone,
        address: this.form2.address,
        id_card_number: this.form2.id_card_number,
        country: this.form2.country,
        native_place: this.form2.native_place,
        profession: this.form2.profession,
        email: this.form2.email,
        age: this.form2.age ? Number(this.form2.age) : -1
      };
      try {
        let self = this;
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation(
              $id: Int!
              $id_in_hospital: String
              $name: String
              $gender: String
              $birthday: String
              $race: String
              $skin_color: String
              $skin_type: String
              $phone: String
              $address: String
              $id_card_number: String
              $native_place: String
              $country: String
              $profession: String
              $email: String
              $age: Int
            ) {
              modifyPatient(
                id: $id
                age: $age
                id_in_hospital: $id_in_hospital
                name: $name
                gender: $gender
                birthday: $birthday
                race: $race
                skin_color: $skin_color,
                skin_type: $skin_type,
                phone: $phone
                address: $address
                id_card_number: $id_card_number
                native_place: $native_place
                country: $country
                profession: $profession
                email: $email
              )
            }
          `,
          variables: params,
          fetchPolicy: "no-cache"
        });
        this.reviseInfo = false;
        this.form2.name = "";
        this.form2.age = "";
        this.form2.gender = "男性";
        this.form2.phone = "";
        this.form2.race = "";
        this.form2.birthday = "";
        this.form2.patientNumber = "";
        this.form2.id = "";
        this.form2.address = "";
        this.form2.skin_color = "";
        this.form2.skin_type = "";
        this.form2.id_card_number = "";
        this.form2.country = "";
        this.form2.native_place = "";
        this.form2.profession = "";
        this.form2.email = "";
        // 刷新患者列表
        await this.refreshPatientList();
        this.$message({
          type: "success",
          message: "修改成功"
        });
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    // 刷新患者列表
    async refreshPatientList() {
      this.patients = [];
      let refreshPatientListRes = await this.$apollo.query({
        query: PatientsGQLByPage,
        variables: {
          page_number: this.currentPagePatientList,
          page_size: this.pageSizePatientList
        },
        fetchPolicy: "no-cache"
      });
      for (const value of refreshPatientListRes.data.patients) {
        // console.log("In refreshPatientList, value:",value);
        
        // 获取患者各类action的数量
        let diagnosesNum = {};
        diagnosesNum = await this.getPatientDiagnoses(value.id);

        const showAge = this.getAge(
          value.birthday,
          value.age,
          value.created_time
        );

        this.patients.push({
          name: value.name,
          gender: value.gender,
          id: value.id,
          doctor_id: value.doctor.id,
          id_in_hospital: value.id_in_hospital,
          phone: value.phone,
          created_time: moment(value.created_time).format("YYYY-MM-DD HH:mm"),
          update_time: moment(value.update_time).format("YYYY-MM-DD HH:mm"),
          birthday: moment(value.birthday).format("YYYY-MM-DD"),
          age: value.age,
          last_diagnosis: value.last_diagnosis,
          address: value.address,
          race: value.race,
          skin_color: value.skin_color,
          skin_type: value.skin_type,
          id_card_number: value.id_card_number,
          native_place: value.native_place,
          country: value.country,
          profession: value.profession,
          email: value.email,
          showAge,
          // 是否勾选
          checked: false,
          printStatus: this.handlePrintStatus(value.diagnoses),
          // check whether online_report_state has error, 2023-11-15
          onlineReportStatus:this.handleOnlineReportStatus(value.last_diagnosis?value.last_diagnosis.online_report_state:''),
          // last_diagnosis 可能为null
          online_report_state: value.last_diagnosis?value.last_diagnosis.online_report_state:'',
          // added by zdh
          diagnosesNum: diagnosesNum,
        });
      }
    },
    // 新建影像检查
    async newDiagnose(event, item) {
      event.cancelBubble = true;
      let params = {};
      params.id = item.id;
      params.birthday = item.birthday;
      params.created_time = item.created_time;
      // params.update_time = item.update_time;
      params.age = item.age;
      params.address = item.address !== "undefined" ? item.address : "";
      params.id_card_number =
        item.id_card_number !== "undefined" ? item.id_card_number : "";
      params.id_in_hospital = item.id_in_hospital;
      params.country = item.country !== "undefined" ? item.country : "";
      params.email = item.email !== "undefined" ? item.email : "";
      params.gender = item.gender;
      params.name = item.name;
      params.native_place =
        item.native_place !== "undefined" ? item.native_place : "";
      params.phone = item.phone;
      params.profession =
        item.profession !== "undefined" ? item.profession : "";
      params.race = item.race;
      params.skin_color = item.skin_color;
      params.skin_type = item.skin_type;

      // Old way. 2025-02-07
      // this.$store.commit("setPToIntell", params);
      // this.$router.push({ name: "Intell" });
      
      // New way. 2025-02-07, modified by Steven. Create new tab for new page. 通过query将指针和参数传递给新页面
      params.from = "newDiagnosis";
      let routeUrl = this.$router.resolve({
        path: "intell",
        query: params
      });
      window.open(routeUrl.href, '_blank');
    },

    // 新建手术记录
    async newOperation(event, item) {
      event.cancelBubble = true;
      let params = {};
      params.id = item.id;
      params.birthday = item.birthday;
      params.created_time = item.created_time;
      params.age = item.age;
      params.address = item.address !== "undefined" ? item.address : "";
      params.id_card_number =
        item.id_card_number !== "undefined" ? item.id_card_number : "";
      params.id_in_hospital = item.id_in_hospital;
      params.country = item.country !== "undefined" ? item.country : "";
      params.email = item.email !== "undefined" ? item.email : "";
      params.gender = item.gender;
      params.name = item.name;
      params.native_place =
        item.native_place !== "undefined" ? item.native_place : "";
      params.phone = item.phone;
      params.profession =
        item.profession !== "undefined" ? item.profession : "";
      params.race = item.race;
      params.skin_color = item.skin_color;
      params.skin_type = item.skin_type;
      this.$store.commit("setPToIntell", params);
      this.$router.push({ name: "operation" });
    },
    // 新建美容/治疗
    newCosmetology(event, item) {
      // this.$store.commit('addCosmetology', {
      //   patient_id: item.id,
      // });
      
      // Old way.
      // this.$router.push({name: 'hairdressing'})

      // New way. 2024-12-09, modified by Steven. Create new tab for new page. 通过query将指针和参数传递给新页面
      let routeUrl = this.$router.resolve({
        path: "hairdressing",
        query: {
          patient_id: item.id,
          from: "newCosmetology"
        }
      });
      window.open(routeUrl.href, '_blank');
      // console.log("In PatientList->newCosmetology, after creat new tab, I am OLD page, patient_id:",item.id);
    },
    async showRevise(event, id) {
      // 重置form表单验证状态
      if (this.$refs.form2Name) {
        this.$refs.form2Name.resetField();
      }
      if (this.$refs.form2Race) {
        this.$refs.form2Race.resetField();
      }
      if (this.$refs.form2Phone) {
        this.$refs.form2Phone.resetField();
      }
      if (this.$refs.form2Id_card_number) {
        this.$refs.form2Id_card_number.resetField();
      }
      event.cancelBubble = true;
      this.activeName = "";
      this.reviseInfo = true;
      this.patientId2 = id;
      let self = this;
      let res = await this.$apollo.query({
        query: gql`
          query($id: Int!) {
            patient(id: $id) {
              id
              name
              gender
              skin_color
              skin_type
              phone
              address
              birthday
              age
              race
              id_in_hospital
              id_card_number
              native_place
              country
              profession
              email
            }
          }
        `,
        variables: {
          id: self.patientId2
        },
        fetchPolicy: "no-cache"
      });
      let resData = res.data.patient;
      this.form2.id = resData.id;
      this.form2.skin_color = resData.skin_color;
      this.form2.name = resData.name;
      this.form2.skin_type = resData.skin_type;
      this.form2.gender = resData.gender;
      this.form2.patientNumber = resData.id_in_hospital;
      this.form2.phone = resData.phone;
      this.form2.race = resData.race;
      this.form2.birthday =
        resData.birthday === this.initialTime
          ? ""
          : moment(resData.birthday).format("YYYY-MM-DD");
      this.form2.age = resData.age > -1 ? resData.age + "" : "";
      this.form2.address = resData.address;
      this.form2.id_card_number = resData.id_card_number;
      this.form2.native_place = resData.native_place;
      this.form2.country = resData.country;
      this.form2.profession = resData.profession;
      this.form2.email = resData.email;
    },

    // // 获取全部患者各类action数量
    // async getPatientsDiagnoses(){
    //   for (const patient of this.patients) {
    //     let patientId = patient.id;
    //     let patientsData = await this.$apollo.query({
    //       query: getPatientsPatientList,
    //       variables: {
    //         id: Number(patientId)
    //       },
    //       fetchPolicy: "no-cache"
    //     });
    //     const filterPatient = patientsData.data.patient; 
    //     let diagnosesNum = {};
    //     diagnosesNum = {
    //       diagnoses: filterPatient.diagnoses.length,
    //       operation: filterPatient.operation.length,
    //       inHospital: filterPatient.hospitalization.length,
    //       cosmetology: filterPatient.cosmetology.length
    //     };
    //     patient.diagnosesNum = diagnosesNum;
    //     //console.log("In getPatientDiagnoses, patientId:", patientId, " diagnosesNum:",diagnosesNum);
    //     //return diagnosesNum
    //   }
    // },
 
    // 获取指定患者各类action数量
    async getPatientDiagnoses(patientId){
      // 旧方法，耗时较多
      let patientsData = await this.$apollo.query({
        query: getPatientsPatientList,
        variables: {
          id: Number(patientId)
        },
        fetchPolicy: "no-cache"
      });
      const filterPatient = patientsData.data.patient; 
      let diagnosesNum = {};
      diagnosesNum = {
        diagnoses: filterPatient.diagnoses.length,
        operation: filterPatient.operation.length,
        inHospital: filterPatient.hospitalization.length,
        cosmetology: filterPatient.cosmetology.length,
        vitiligoBasicInfo: filterPatient.vitiligoBasicInfo.length,
        mmBasicInfo: filterPatient.mmBasicInfo.length
      };

      // 新方法，2024-1217. 需要与后台v3.7.2匹配
      // let patientsData = await this.$apollo.query({
      //   query: getPatientActionNum,
      //   variables: {
      //     id: Number(patientId)
      //   },
      //   fetchPolicy: "no-cache"
      // });
      // const filterPatient = patientsData.data.patient; 
      // let diagnosesNum = {};
      // diagnosesNum = {
      //   diagnoses: filterPatient.diagnoses_num,
      //   operation: filterPatient.operation_num,
      //   inHospital: filterPatient.hospitalization_num,
      //   cosmetology: filterPatient.cosmetology_num
      // };
      // console.log("In getPatientDiagnoses, patientId:", patientId, " diagnosesNum:",diagnosesNum);
      return diagnosesNum
    },

    // 获取患者信息，带搜索条件或者不带搜索条件，有排序或者无排序
    async getCohortPatients() {
      // BUG5: 空值守卫，currentCohortId 为 null 时不发起请求
      if (!this.currentCohortId) {
        this.patients = [];
        this.pageTotal = 0;
        return;
      }
      try {    
        let res;        
        this.getPatientListLoading = true;
        // console.time("getCohortPatients-runtime");
        res = await this.$apollo.query({
          query: getCohortPatientsGql,
          variables: {
            cohortId: this.currentCohortId, // 来自cohort.js
            page: this.currentPagePatientList,
            pageSize: this.pageSizePatientList
          },
          fetchPolicy: "no-cache"
        });
        // console.timeEnd("getCohortPatients-runtime");
        this.getPatientListLoading = false;

        this.patients = [];
        this.pageTotal = res.data.getCohortPatients.total
        for (const CohortPatientDetail of res.data.getCohortPatients.list) {
          // BUG1: patient 是 [Patient] 数组，取第一个元素
          let value = (CohortPatientDetail.patient && CohortPatientDetail.patient[0]) || {};
          //获取患者各类action的数量
          let diagnosesNum = {};
          diagnosesNum = await this.getPatientDiagnoses(value.id);
          
          // console.log("In getCohortPatients, diagnosesNum:",diagnosesNum);
          //console.log("diagnosesNum.operationNum:",diagnosesNum.operationNum);
          // this.patients.push({
          //   "diagnosesNum": diagnosesNum,
          // });

          // 算年龄
          const showAge = this.getAge(
            value.birthday,
            value.age,
            value.created_time
          );
          this.patients.push({
            name: value.name,
            gender: value.gender,
            id: value.id,
            id_in_hospital: value.id_in_hospital,
            phone: value.phone,
            created_time: moment(value.created_time).format("YYYY-MM-DD HH:mm"),
            update_time: moment(value.update_time).format("YYYY-MM-DD HH:mm"),
            birthday: moment(value.birthday).format("YYYY-MM-DD"),
            age: value.age,
            // diagnoses: value.diagnoses,
            address: value.address,
            race: value.race,
            skin_color: value.skin_color,
            skin_type: value.skin_type,
            id_card_number: value.id_card_number,
            native_place: value.native_place,
            country: value.country,
            profession: value.profession,
            last_diagnosis_text:this.formatConclusion(value.last_diagnosis_text),
            email: value.email,
            showAge,
            // 是否勾选
            checked: false,
            // printStatus: this.handlePrintStatus(value.diagnoses),          
            // check whether online_report_state has error, 2023-11-15
            // onlineReportStatus:this.handleOnlineReportStatus(value.last_diagnosis?value.last_diagnosis.online_report_state:''),
            // last_diagnosis 可能为null
            // online_report_state: value.last_diagnosis?value.last_diagnosis.online_report_state:'',          
            // added by zdh
            diagnosesNum: diagnosesNum,
          });

        }
        // console.log("After get patients in getCohortPatients(), length:",this.patients.length);
        
        return res.data.getCohortPatients;
      }catch(error) {
        console.log("getCohortPatients error:",error)
        this.getPatientListLoading = false;        
      }
    },

    formatConclusion(id) {
      let name;
      // 从自定义模板中找病种名称
      const f = data => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].id === id) {
            name = data[i].name;
            break;
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      // 如果自定义中没有找到则在原始模板中查找
      if (!name) {
        if (this.knowledgeDic[id]) {
          name = this.knowledgeDic[id].name;
        }
      }
      return name ? name : id;
    },
    // 点击某患者诊断卡片后，跳转到按日期滚动排序的详细就诊记录
    getInfo(id, id2, type) {
      this.showInfo = true;
      this.singleDiagnose = true;
      this.patientId = id2;
      this.diagnosisId = id;
      const params = {
        patientId: id2,
        selectId: id,
        diagnosisType: type
      };
      // console.log("In patientlist, getInfo."); 
      
      //采用全局变量缓存参数
      this.$store.commit("setPatientDiagnosisRecordPara", {
          patientId: params.patientId,
          selectId: params.selectId,
          diagnosisType: params.diagnosisType
      });
      this.$router.push({ name: "details" });

      // // 不跳转新标签页,采用sessionStorage缓存参数
      // if (window.sessionStorage) {
      //   this.$router.push({ name: "details" });
      //   window.sessionStorage.setItem(
      //     "diagnosisParams",
      //     JSON.stringify(params)
      //   );
      // } else {
      //   this.$router.push({
      //     name: "details",
      //     params
      //   });
      // }

      // 跳转新标签页,采用sessionStorage缓存参数
      // if (window.sessionStorage) {
      //   window.sessionStorage.setItem(
      //     "diagnosisParams",
      //     JSON.stringify(params)
      //   );
      //   let routeUrl = this.$router.resolve({
      //     path: "details",
      //     //query: {id:96}
      //   });
      //   window.open(routeUrl.href, '_blank');
      //   console.log("In getInfo, sessionStorage is true; after creat new tab, I am OLD page");
      // } else {
      //   let routeUrl = this.$router.resolve({
      //     path: "details",
      //     query: params
      //   });
      //   window.open(routeUrl.href, '_blank');
      //   console.log("In getInfo, sessionStorage is false; after creat new tab, I am OLD page");
      // }

      // setTimeout(() => {
      //   this.refreshPatientList();
      //   //this.getCohortPatients();
      //   console.log("In getInfo, after refreshPatientList.");
		  // }, 3000);


    },
    

    // 展开一个患者的详细action/item，包括diagnosis/inhospital/operation/cosmetology
    async changeHandler(patientId) {
      // console.log("In changeHandler, patientId:",patientId, "this.activeName:",this.activeName);
      this.waiting = true;
      this.showall = false;
      // this.hasClumsOpen = !this.hasClumsOpen
      if (patientId) {
        let patientsData = await this.$apollo.query({
          query: getPatientsPatientList,
          variables: {
            id: Number(patientId)
          },
          fetchPolicy: "no-cache"
        });
        const filterPatient = patientsData.data.patient;
        for (const diagnosesItem of filterPatient.diagnoses) {
          const index = diagnosesItem.images.findIndex(
            item => item.print_time !== this.initialTime
          );
          diagnosesItem.isPrintReport = !(index > -1);
        }
        this.resultArr = [];
        if (this.activeName !== "") {
          if (patientId === this.activeName) {
            this.diagnoses = filterPatient.diagnoses;
            let inHospitalData = filterPatient.hospitalization;
            let operationData = filterPatient.operation;
            let hairdressingData = filterPatient.cosmetology;
            let vitiligoBasicInfo = filterPatient.vitiligoBasicInfo;
            let mmBasicInfoData = filterPatient.mmBasicInfo;
            // 处理影像数据
            for (let n = 0; n < this.diagnoses.length; n++) {
              this.diagnoses[n].time1 = this.diagnoses[n].time;
              this.diagnoses[n].time = moment(this.diagnoses[n].time).format(
                "YYYY-MM-DD HH:mm"
              );
              this.diagnoses[n].typeDignoses = "影像";
              if (this.diagnoses[n].images.length > 0) {
                // 将图片的宽高获取到
                let imgZeroObj = this.diagnoses[n].images[0];
                let newImgZeroObj = await this.getImgWidth(
                  api.imageSrcPrefixThumbnails + imgZeroObj.path
                );
                imgZeroObj.width = newImgZeroObj.width;
                imgZeroObj.height = newImgZeroObj.height;
              }
            }
            // 处理住院数据
            for (let n = 0; n < inHospitalData.length; n++) {
              let inHospitalArray = {};
              inHospitalArray = inHospitalData[n];
              inHospitalArray.remarks =  inHospitalData[n].remarks;
              inHospitalArray.disease_course  =  inHospitalData[n].disease_course;
              inHospitalArray.time1 = inHospitalData[n].update_time;
              inHospitalArray.update_time = inHospitalData[n].update_time?moment(inHospitalData[n].update_time).format("YYYY-MM-DD") : "";
              inHospitalArray.time = moment(
                inHospitalData[n].created_time
              ).format("YYYY-MM-DD HH:mm");
              inHospitalArray.inpat_date =
                inHospitalData[n].inpat_date !== this.initialTime
                  ? moment(inHospitalData[n].inpat_date).format("YYYY-MM-DD")
                  : "";
              inHospitalArray.outpat_date =
                inHospitalData[n].outpat_date !== this.initialTime
                  ? moment(inHospitalData[n].outpat_date).format("YYYY-MM-DD")
                  : "";
              inHospitalArray.typeDignoses = "住院";
              await this.diagnoses.push(inHospitalArray);
              if (inHospitalArray.image_hospitalization.length > 0) {
                // 将图片的宽高获取到
                let imgZeroObj2 =
                  inHospitalArray.image_hospitalization[
                    inHospitalArray.image_hospitalization.length - 1
                  ];
                let newImgZeroObj = await this.getImgWidth(
                  api.hospitalization_imagesThumbnails + imgZeroObj2.path
                );
                imgZeroObj2.width = newImgZeroObj.width;
                imgZeroObj2.height = newImgZeroObj.height;
              }
            }
            // 处理手术数据
            for (let n = 0; n < operationData.length; n++) {
              let operationArray = {};
              operationArray = operationData[n];
              operationArray.time1 = operationData[n].update_time;
              operationArray.typeDignoses = "手术";
              await this.diagnoses.push(operationArray);
            }
            
            // 处理美容数据
            // console.log("hairdressingData:", hairdressingData);
            for (let n = 0; n < hairdressingData.length; n++) {
              let hairdressingArray = {};
              hairdressingArray = hairdressingData[n];
              hairdressingArray.time1 = hairdressingData[n].create_time;
              hairdressingArray.typeDignoses = "美容";
              hairdressingArray.title = "";
              hairdressingArray.total = hairdressingArray.total_times;
              hairdressingArray.leftNum = hairdressingArray.current_times;
              // console.log(hairdressingArray)
              hairdressingArray.time = moment(
                hairdressingData[n].create_time
              ).format("YYYY-MM-DD HH:mm");
              for (
                let m = 0;
                m < hairdressingData[n].treat_details.length;
                m++
              ) {
                if (m === hairdressingData[n].treat_details.length - 1) {
                  // 2024-12-09, modified by Steven. 之前呈现的项目名称，修改后呈现的模块/药物
                  // if (hairdressingData[n].treat_details[m].item_info) {
                  //   hairdressingArray.title +=
                  //     hairdressingData[n].treat_details[m].item_info.item_name;
                  // }
                  if (hairdressingData[n].treat_details[m].module_info) {
                    hairdressingArray.title +=
                      hairdressingData[n].treat_details[m].module_info.module_name;
                  }

                } else {
                  // 2024-12-09, modified by Steven. 之前呈现的项目名称，修改后呈现的模块/药物
                  // if (hairdressingData[n].treat_details[m].item_info) {
                  //   hairdressingArray.title +=
                  //     hairdressingData[n].treat_details[m].item_info.item_name +
                  //     ",";
                  // }
                  if (hairdressingData[n].treat_details[m].module_info) {
                    hairdressingArray.title +=
                      hairdressingData[n].treat_details[m].module_info.module_name +
                      ",";
                  }
                }
                // if (m === 0) {
                //   hairdressingArray.total =
                //     hairdressingData[n].treat_details[m].total_times;
                //   hairdressingArray.leftNum =
                //     hairdressingData[n].treat_details[m].total_times -
                //     hairdressingData[n].treat_details[m].left_times;
                // }
              }
              if (hairdressingData[n].image_cosmetology.length > 0) {
                // 将图片的宽高获取到
                let imgZeroObj = hairdressingData[n].image_cosmetology[0];
                let newImgZeroObj = await this.getImgWidth(
                  api.cosmetology_imagesThumbnails + imgZeroObj.path
                );
                imgZeroObj.width = newImgZeroObj.width;
                imgZeroObj.height = newImgZeroObj.height;
              }
              await this.diagnoses.push(hairdressingArray);
            }
            // 处理白癜风基础数据
            for (let n = 0; n < vitiligoBasicInfo.length; n++) {
              let vitiligoBasicInfoArray = {};
              vitiligoBasicInfoArray = this.transformVitiligoData(vitiligoBasicInfo[n]); // 数字和日期格式化
              vitiligoBasicInfoArray.time1 = vitiligoBasicInfo[n].visit_date;
              vitiligoBasicInfoArray.update_time = vitiligoBasicInfo[n].update_time?moment(vitiligoBasicInfo[n].update_time).format("YYYY-MM-DD") : "";
              vitiligoBasicInfoArray.time = moment( vitiligoBasicInfo[n].created_time ).format("YYYY-MM-DD HH:mm");
              vitiligoBasicInfoArray.visit_date = vitiligoBasicInfo[n].visit_date ? moment(vitiligoBasicInfo[n].visit_date).format("YYYY-MM-DD") : "";
              
              vitiligoBasicInfoArray.typeDignoses = "白癜风基础";
              await this.diagnoses.push(vitiligoBasicInfoArray);              
            }
            // 处理黑色素瘤基础数据
            for (let n = 0; n < mmBasicInfoData.length; n++) {
              let mmBasicInfoArray = {};
              mmBasicInfoArray = this.transformMmData(mmBasicInfoData[n]); // 数字和日期格式化
              mmBasicInfoArray.time1 = mmBasicInfoData[n].visit_date;
              mmBasicInfoArray.update_time = mmBasicInfoData[n].update_time?moment(mmBasicInfoData[n].update_time).format("YYYY-MM-DD") : "";
              mmBasicInfoArray.time = moment( mmBasicInfoData[n].create_time ).format("YYYY-MM-DD HH:mm");
              mmBasicInfoArray.visit_date = mmBasicInfoData[n].visit_date ? moment(mmBasicInfoData[n].visit_date).format("YYYY-MM-DD") : "";
              
              mmBasicInfoArray.typeDignoses = "黑色素瘤";
              await this.diagnoses.push(mmBasicInfoArray);              
            }

          }
          this.waiting = false;
          let sumList1 = _.cloneDeep(this.diagnoses);
          let sumList = _.sortBy(sumList1, item => {
            return -item.time1;
          });
          if (sumList.length > 0) {
            this.resultArr = _.chunk(sumList, 4);
            let newarr = _.cloneDeep(this.resultArr);
            this.moreResultArr = _.drop(newarr);
          } else {
            this.resultArr = [];
            // this.$message.error("暂无诊断数据");
          }
        } else {
          this.resultArr = [];
          this.moreResultArr = [];
          this.showall = false;
        }
      }
      // 处理数据查看是否有打印过报告
      // if (patientId) {
      //   const filterPatient = this.patients.filter(item => item.id === patientId);
      //   for (const diagnosesItem of filterPatient[0].diagnoses) {
      //     const index = diagnosesItem.images.findIndex(item => item.print_time !== this.initialTime)
      //     diagnosesItem.isPrintReport = !(index > -1)
      //   }
      // }
    },
    getImgWidth(path) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        let aa = {};
        img.src = path;
        img.onload = () => {
          let width = img.width;
          let height = img.height;
          if (width / height < 155 / 115) {
            img.height = 115;
            img.width = (width * 115) / height;
          } else {
            img.width = 155;
            img.height = (height * 155) / width;
          }
          // imgZeroObj.width = img.width;
          // imgZeroObj.height = img.height;
          resolve({ width: img.width, height: img.height });
        };
      });
    },
    showDelete(id) {
      this.deletePatientId = id;
      this.isdel = true;
    },
    closeInfo() {
      this.showInfo = false;
    },
    // 编辑诊断
    async modifyDiagnosis(diagnosisId) {
      // 请求相关数据
      try {
        
        // patientinfo.birthday = moment(patientinfo.birthday).format(
        //   "YYYY-MM-DD"
        // );

        // Open new page in current tab. 2023-0928, by zdh
        // this.$store.commit("addModifyDiagnosis", {
        //   diagnosisId
        // });        
        // this.$router.push("/home/intell");

        // Open new page in new tab. 通过query将指针和参数传递给新页面
        let routeUrl = this.$router.resolve({
          path: "intell",
          query: {
            diagnosisId:diagnosisId,
            from: "modifyDiagnosis"
          }
        });
        window.open(routeUrl.href, '_blank');
        // console.log("In modifyDiagnosis, after creat new tab, I am OLD page, diagnosisId:",diagnosisId);

        // Open new page in new tab. 通过sessionStorage将指针和参数传递给新页面。this.$store.commit("addModifyDiagnosis")不能跨页面传输信息。
        // sessionStorage.diagnosisParams 会在 Intelligent.vue中，用完后销毁。
        // if (window.sessionStorage) {
        //   window.sessionStorage.setItem(
        //     "diagnosisParams",
        //     JSON.stringify({'diagnosisId':diagnosisId})
        //   );
        //   let routeUrl = this.$router.resolve({
        //     path: "intell",
        //     query: {diagnosisId:diagnosisId}
        //   });
        //   window.open(routeUrl.href, '_blank');
        // } else {
        //   let routeUrl = this.$router.resolve({
        //     path: "intell",
        //     query: {'diagnosisId':diagnosisId}
        //   });
        //   window.open(routeUrl.href, '_blank');          
        // }            
        // console.log("In modifyDiagnosis,modifyDiagnosisData.isModify and diagnosisId:",this.$store.state.modifyDiagnosisData.isModify, this.$store.state.modifyDiagnosisData.diagnosisId);
        // console.log("In modifyDiagnosis,window.sessionStorage:",window.sessionStorage);   
      
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    
    // 获取onlineReport 详细信息，并打开对话框大图显示
    // id 为''时表示未生成云胶片或者生成失败；online_report_state 始终不为空；download_time为null时表示患者尚未查阅；names为图片名称数组，base64为图片数据数组
    async showOnlineReport(id){
      try {
        this.onlineReport = {};
        const res = await this.$apollo.mutate({
          mutation: gql`mutation($diagnosis_id: Int!){
                      getOnlineReport(diagnosis_id: $diagnosis_id) {
                        id
                        create_time
                        download_time
                        online_report_state
                        names
                        base64
                        note 
                      }
                  }`,
          fetchPolicy: "no-cache",
          variables: {
            diagnosis_id: id,
          },
        });
        // console.log("getOnlineReport,data:",res.data.getOnlineReport);
        if(res.data.getOnlineReport.create_time){
          this.onlineReport['created_time'] = moment(res.data.getOnlineReport.create_time).format("YYYY-MM-DD HH:mm");
        }else{
          this.onlineReport['created_time'] = '';
        }
        if(res.data.getOnlineReport.download_time){
          this.onlineReport['download_time'] = moment(res.data.getOnlineReport.download_time).format("YYYY-MM-DD HH:mm");
        }else{
          this.onlineReport['download_time'] = '';
        }    
        this.onlineReport['id'] = res.data.getOnlineReport.id;
        this.onlineReport['note'] = res.data.getOnlineReport.note; // string; sent sms tines;
        this.onlineReport['online_report_state'] = res.data.getOnlineReport.online_report_state;
        this.onlineReport['names'] = res.data.getOnlineReport.names;
        this.onlineReport['base64'] = [];
        this.onlineReport['imgNum'] = res.data.getOnlineReport.base64.length;

        for(let img of res.data.getOnlineReport.base64){
          this.onlineReport['base64'].push('data:image/png;base64,' + img );
        }
        // console.log("getOnlineReport,onlineReport:",this.onlineReport);
        this.showOnlineReportDetail = true;
      }catch (error) {
        console.log("in showOnlineReport，error:",error);
        this.$message.error(error.message.split(":")[1]);
      }

    },

    // 关闭 onlineReport 对话框大图显示
    async closeOnlineReport(){
      this.showOnlineReportDetail = false;
    },
    
    // 重新发送短信通知（为当前打开详情的云胶片）
    async resendSMSNotification(){
      try {
        let online_report_id = this.onlineReport['id'];  //  该值来自 showOnlineReport()
        if(online_report_id){
          if(!this.onlineReport['note'] ||  this.onlineReport['note'] < this.maxSmsSentTimes){         
            const res = await this.$apollo.mutate({
              mutation: gql`mutation($online_report_id: Int!){
                          resendSMSNotification(online_report_id: $online_report_id) 
                      }`,
              fetchPolicy: "no-cache",
              variables: {
                online_report_id: online_report_id,
              },
            });
            // console.log("Get resendSMSNotification result:",res.data.resendSMSNotification);
            // 返回值为""，代表异常
            if(!res.data.resendSMSNotification){
              this.$message({
                type: "error",
                message: "重发短信失败！"
              });
              // 重发成功，返回值为字符串,如"1" "2"
            }else{
              this.onlineReport['note'] = res.data.resendSMSNotification;
              this.$message({
                type: "success",
                message: "重发短信成功！"
              });
            }

          }else{
            this.$message({
              type: "error",
              message: "已达短信发送最大次数！"
            });
          }
        }

      }catch (error) {
        // console.log("in resendSMSNotification:",error);
        this.$message.error(error.message.split(":")[1]);
      }
    },

    // 是否显示编辑按钮
    isShowModifyDiagnosisBtn(date) {
      return !(moment().diff(date) >= this.countTimeModifyDiagnosisBtn);
    },
    // 编辑美容
    async modifyCosmetology(item) {
      // Old way.
      // this.$store.commit('addModifyCosmetology', {
      //   patient_id: item.patient_id,
      //   treat_no: item.treat_no,
      //   current_times: item.current_times,
      //   total_times: item.total_times,
      //   parent_id: item.parent_id ? item.parent_id : item.treat_no,
      // });
      // this.$router.push({name: 'hairdressing'});
      
      // New way. 2024-12-12, modified by Steven. Create new tab for new page. 通过query将指针和参数传递给新页面
      let routeUrl = this.$router.resolve({
        path: "hairdressing",
        query: {
          patient_id: item.patient_id,
          treat_no: item.treat_no,
          current_times: item.current_times,
          total_times: item.total_times,
          parent_id: item.parent_id ? item.parent_id : item.treat_no,
          from: "modifyCosmetology"
        }});
      window.open(routeUrl.href, '_blank');
      // console.log("In PatientList->newCosmetology, after creat new tab, I am OLD page, patient_id:",item.id);
    }
  },
  components: {
    swiper,
    swiperSlide,
    PatientDiagnoseRecord,
    DetailedResults
  },
  filters: {
    formatTime(time) {
      return moment(time).format("YYYY-MM-DD HH:mm");
    },
    formatTime1(time) {
      return moment(time).format("YYYY-MM-DD");
    },
    formatConclusion(id) {
      let name;
      // 从自定义模板中找病种名称
      const f = data => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].id === id) {
            name = data[i].name;
            break;
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      // 如果自定义中没有找到则在原始模板中查找
      if (!name) {
        if (that.wordbook[id]) {
          name = that.wordbook[id].name;
        }
      }
      return name ? name : id;
    }
  }
};
